import { setCORS } from "google-translate-api-browser";
const translate = setCORS("http://cors-anywhere.herokuapp.com/");

document.querySelectorAll('[data-translate]').forEach(el => {
  if (!el.innerHTML || !el.innerHTML.trim()) {
    return
  }

  translate(el.innerHTML.trim(), { to: "en" })
    .then(res => {
      if (res.text) {
        let text = res.text.replace('& amp;', '&amp;')
        el.innerHTML = text
      }
    })
    .catch(err => {
      console.error(err);
    })
})




// WEBPACK FOOTER //
// ./resources/assets/js/pages/translate.js